import i18next from 'i18next';

function toolTranslations(
  id: string,
  label: string,
  options?: { reasoning?: string; output?: string; noop?: string },
): Record<string, string> {
  return {
    [id]: label,
    [`${id}Reasoning`]: options?.reasoning ?? label,
    [`${id}Output`]: options?.output ?? `Completed: ${label}`,
    [`${id}Noop`]: options?.noop ?? `No results: ${label}`,
    [`${id}Error`]: `Error: ${label}`,
  };
}

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'ai-tool', {
    ...toolTranslations('createBot', 'Create bot', {
      reasoning: 'Creating bot',
      output: 'Created bot',
    }),
    ...toolTranslations('updateBot', 'Update bot', {
      reasoning: 'Updating bot',
      output: 'Updated bot',
    }),
    ...toolTranslations('readBot', 'Read bot', {
      reasoning: 'Reading bot',
      output: 'Read bot',
    }),
    ...toolTranslations('trashBot', 'Trash bot', {
      reasoning: 'Trashing bot',
      output: 'Trashed bot',
    }),
    ...toolTranslations('findBots', 'Find bots', {
      reasoning: 'Finding bots',
      output: 'Found {{count}} bots',
      noop: 'No bots found',
    }),
    ...toolTranslations('searchBots', 'Search bots', {
      reasoning: 'Searching bots for {{toolCall.input.query}}',
      output: 'Found {{count}} bots',
      noop: 'No bots found',
    }),
    ...toolTranslations('createPrompt', 'Create prompt', {
      reasoning: 'Creating prompt',
      output: 'Created prompt',
    }),
    ...toolTranslations('updatePrompt', 'Update prompt', {
      reasoning: 'Updating prompt',
      output: 'Updated prompt',
    }),
    ...toolTranslations('readPrompt', 'Read prompt', {
      reasoning: 'Reading prompt',
      output: 'Read prompt',
    }),
    ...toolTranslations('trashPrompt', 'Trash prompt', {
      reasoning: 'Trashing prompt',
      output: 'Trashed prompt',
    }),
    ...toolTranslations('findPrompts', 'Find prompts', {
      reasoning: 'Finding prompts',
      output: 'Found {{count}} prompts',
      noop: 'No prompts found',
    }),
    ...toolTranslations('searchPrompts', 'Search prompts', {
      reasoning: 'Searching prompts for {{toolCall.input.query}}',
      output: 'Found {{count}} prompts',
      noop: 'No prompts found',
    }),
    ...toolTranslations('updateBotPrompts', 'Update bot prompts', {
      reasoning: 'Updating bot prompts',
      output: 'Updated bot prompts',
    }),
    ...toolTranslations('findAiModels', 'Find AI models', {
      reasoning: 'Finding AI models',
      output: 'Found {{count}} AI models',
      noop: 'No AI models found',
    }),
    ...toolTranslations('searchAiModels', 'Search AI models', {
      reasoning: 'Searching AI models for {{toolCall.input.query}}',
      output: 'Found {{count}} AI models',
      noop: 'No AI models found',
    }),
    ...toolTranslations('readAiModel', 'Read AI model', {
      reasoning: 'Reading AI model',
      output: 'Read AI model',
    }),
  });
}
